import React from 'react';
import { useState, useEffect } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FaUserEdit } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import "./Add_installation.css"
import FiberTeam from './FiberTeam';
import NetworkTeam from './NetworkTeam';
import { useSelector } from "react-redux";


export default function WorkAssign({ installDetails,
  setinstallDetails,
  isSubmitting,
  fiberTeamStock,
  setFiberTeamStock,
  networkTeamStock,
  setNetworkTeamStock,
  activeTabWorkAssign,
   setActiveTabWorkAssign,
  
}) {
  // const [activeTabWorkAssign, setActiveTabWorkAssign] = useState("fiberTeam");
  console.log(setinstallDetails)
  const staffName = useSelector((state) => state.staffname);



  // useEffect(() => {
  //   // Sync to parent installDetails when fiberTeamStock updates
  //   setinstallDetails((prev) => ({
  //     ...prev,
  //     workAssign: {
  //       ...(prev.workAssign || {}),
  //       fiberTeam: fiberTeamStock,
  //     },
  //   }));
  // }, [fiberTeamStock]);




  // useEffect(() => {
  //   // Sync to parent installDetails when fiberTeamStock updates
  //   setinstallDetails((prev) => ({
  //     ...prev,
  //     workAssign: {
  //       ...(prev.workAssign || {}),
  //       networkTeam: networkTeamStock,
  //     },
  //   }));
  // }, [networkTeamStock]);


  const renderContentWorkAssign = () => {
    switch (activeTabWorkAssign) {
      case "fiberTeam":
        return <div>

          <FiberTeam  isSubmitting={isSubmitting} installDetails={installDetails} setinstallDetails={setinstallDetails} stock={fiberTeamStock} setStock={setFiberTeamStock} />
        </div>;
      case "networkTeam":
        return <div>
          <NetworkTeam installDetails={installDetails} setinstallDetails={setinstallDetails} stock={networkTeamStock} setStock={setNetworkTeamStock} />

        </div>;

      default:
        return <div>Select a tab</div>;
    }
  };

  return (
    <div className="tabs-container-workassign mt-3 ">
      {/* Tabs */}
      <div className="tabs-wokassign">
       <Row>
  <button
    className={`fiber-button-workassign ${activeTabWorkAssign === "fiberTeam" ? "active-tab" : ""}`}
    type="button"
    onClick={() => setActiveTabWorkAssign("fiberTeam")}
  >
    Fiber Team
  </button>
{installDetails?.workAssign?.fiberTeam?.approvedStatus === "Approved" && (
  <button
    className={`fiber-button-workassign ms-5 ${activeTabWorkAssign === "networkTeam" ? "active-tab" : ""}`}
    type="button"
    onClick={() => setActiveTabWorkAssign("networkTeam")}
  >
    Network Team
  </button>
)}

</Row>


      </div>

      {/* Dynamic Content */}
      <div className='fiber-workassign mt-3'>

        {renderContentWorkAssign()}






      </div>



    </div>

  )
}
